import { useCallback, useContext } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import ArticleSearchResponseContext from 'components/pages/ArticleUniverse/components/Filter/context/ArticleSearchResponseContext';
import CheckBox from 'components/shared/inputs/checkbox';
import isSelected from '../../helpers/isSelected';
import type { FilterOptionType, SelectType, ToggleOptionToFilterArrayType } from '../../shared/types';

const CheckboxLabel = styled.label`
    display: flex;
    gap: ${Spacing8};
    align-items: center;
    margin-bottom: 0;
`;

type CheckBoxType = {
    selectOption: FilterOptionType;
    selectType: SelectType;
    toggleOptionToFilterArray: (data: ToggleOptionToFilterArrayType) => void;
};

function CheckboxFilter({ selectOption, selectType, toggleOptionToFilterArray }: CheckBoxType) {
    const { entryId, publicName, queryParameterName } = selectOption;
    const articleSearchResponseContext = useContext(ArticleSearchResponseContext);

    const handleChange = useCallback(
        (event) => {
            const isChecked = event.currentTarget.checked;
            toggleOptionToFilterArray({ queryParameterNames: isChecked ? [queryParameterName] : [], selectType });
        },
        [queryParameterName, selectType, toggleOptionToFilterArray]
    );

    return (
        <CheckboxLabel>
            <CheckBox
                value={entryId}
                defaultChecked={isSelected(entryId, selectType, articleSearchResponseContext?.data)}
                onChange={handleChange}
            />
            <Typography.Body>{publicName}</Typography.Body>
        </CheckboxLabel>
    );
}

export default withErrorBoundary(CheckboxFilter, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
